export default "__VITE_ASSET__TwTA$o4g__"